var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"case"},[_vm._v("Case studies")]),_c('Datavisualization',{attrs:{"project":_vm.projects[5]}}),_c('CaseStudy',{attrs:{"project":_vm.projects[0]}}),_c('galleryroom',{attrs:{"project":_vm.projects[1]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }